<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="filtroNome"
          label="Buscar por nome"
          prepend-icon="mdi-magnify"
          class="mb-4"
          clearable
        />
        <v-spacer />
        <!-- <v-btn color="primary" @click="adicionarPessoa">Adicionar Novo</v-btn> -->
      </v-card-title>

      <v-card-text>
        <div v-for="(pessoa, index) in pessoasFiltradas" :key="index" class="mb-8">
          <v-card class="pa-4">
            <v-tabs v-model="abas[index]" background-color="primary" dark grow>
              <v-tab>Identificação</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abas[index]">
              <v-tab-item>
                <v-row class="mt-5">
                  <v-col cols="4" v-if="professores">
                    <e-autocomplete
                      :items="professores"
                      :return-object="false"
                      :item-value="(value) => value.codigo_pessoa_fisica_sistema"
                      :item-text="
                        (val) => `${val.codigo_pessoa_fisica_sistema} - ${val.nomecompleto}`
                      "
                      v-model="pessoa.cod_pessoa_fisica_sistema"
                      label="Selecione um professor"
                      dense
                      solo
                    />
                  </v-col>

                  <v-col cols="4">
                    <e-autocomplete
                      :items="turmasCenso20"
                      :return-object="false"
                      :item-value="(value) => value.codigo_turma_entidade"
                      :item-text="(val) => `${val.codigo_turma_entidade} - ${val.turma.descricao}`"
                      v-model="pessoa.codigo_turma_entidade"
                      label="Selecione uma turma"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <e-autocomplete
                      :items="$constants.areaConhecimentoCurricularList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => `${val.nome}`"
                      v-model="pessoa.areas_conhecimento_escolhidas"
                      label="Áreas do conhecimento/componentes curriculares que leciona nessa turma"
                      dense
                      multiple
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <e-autocomplete
                      :items="[
                        '1 – Docente',
                        '2 – Auxiliar/assistente educacional',
                        '3 – Profissional/monitor de atividade complementar',
                        '4 – Tradutor e Intérprete de Libras',
                        '5 – Docente titular - coordenador de tutoria (de módulo ou disciplina) - EAD',
                        '6 – Docente tutor - auxiliar (de módulo ou disciplina) - EAD',
                        '7 – Guia-Intérprete',
                        '8 – Profissional de apoio escolar para aluno(a)s com deficiência (Lei 13.146/2015)',
                        '9 – Instrutor da Educação Profissional',
                      ]"
                      v-model="pessoa.funcao_na_turma"
                      label="Função na turma"
                      solo
                      class="px-2"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="[
                        '1 - Concursado/efetivo/estável',
                        '2 - Contrato temporário',
                        '3 - Contrato terceirizado',
                        '4 - Contrato CLT',
                      ]"
                      v-model="pessoa.situacao_funcional"
                      label="Situação Funcional/Regime de contratação/Tipo de vínculo"
                      solo
                      class="px-2"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.area_linguagens"
                      label="Linguagens e suas tecnologias"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.area_matematica"
                      label="Matemática e suas tecnologias"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.area_ciencia_natureza"
                      label="Ciências da natureza e suas tecnologias"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.area_ciencia_humana"
                      label="Ciências humanas e socias aplicadas"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.area_ifpt"
                      label="Profissional escolar leciona no Itinerário de formação técnica e profissional(IFTP)"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
        <v-row class="mt-4">
          <v-col cols="6">
            <v-btn block color="error" @click="submitForm('prev')">
              <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn block color="success" @click="submitForm('next')">
              <v-icon>mdi-chevron-right</v-icon> Próxima Etapa</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="erros.length > 0">
          <v-col cols="12" class="mt-4" style="background-color: red; color: white">
            <v-card-title>Erros encontrados no preenchimento dos dados</v-card-title>
            <v-card-text>
              <ul v-for="(erro, index) in erros" :key="index">
                <li>{{ erro.mensagem }}</li>
              </ul>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    pessoasFiltradas() {
      if (!this.filtroNome) return this.pessoas;
      return this.pessoas.filter((p) =>
        p.nomecompleto?.toLowerCase().includes(this.filtroNome.toLowerCase())
      );
    },
  },
  data() {
    return {
      erros: [],
      filtroNome: "",
      emailRule: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      pessoas: [{}],
      abas: [0],
      binarios: ["0", "1"],
      sexos: ["1 - Masculino", "2 - Feminino", "3 - Outro"],
      cores: [
        "0 - Não Declarada",
        "1 - Branca",
        "2 - Preta",
        "3 - Parda",
        "4 - Amarela",
        "5 - Indígena",
      ],
      nacionalidades: [
        "1 - Brasileira",
        "2 - Brasileira - nascido no Exterior ou Naturalizado",
        "3 - Estrangeira",
      ],
      menu: false,
      deficiencias: [
        "cegueira",
        "baixa_visao",
        "visao_monocular",
        "surdez",
        "deficiencia_auditiva",
        "surdocegueira",
        "deficiencia_fisica",
        "deficiencia_intelectual",
        "deficiencia_multipla",
        "transtorno_espectro_autista",
        "altas_habilidades_superdotacao",
        "transtornos_aprendizagem",
        "discalculia",
        "disgrafia_disortografia",
        "dislalia",
        "dislexia",
        "tdah",
        "tpac",
      ],
      recursos: [
        "auxilio_ledor",
        "auxilio_transcricao",
        "guia_interprete",
        "tradutor_interprete_libras",
        "leitura_labial",
        "prova_ampliada",
        "prova_super_ampliada",
        "cd_audio",
        "prova_lingua_portuguesa",
        "prova_video_libras",
        "material_didatico_braille",
        "prova_em_braille",
        "tempo_adicional",
        "nenhum_recurso",
        "",
      ],
      municipiosNasc: [],
      municipiosRes: [],
      professores: [],
      turmasCenso20: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    validacao() {
      this.erros = [];

      this.pessoas.forEach((vinculo, index) => {
        // Exemplo de outro campo obrigatório (ajuste conforme necessário)
        if (vinculo.areas_conhecimento_escolhidas.length === 0) {
          this.erros.push({
            tipo: `areas_conhecimento_escolhidas-${index}`,
            mensagem: `Gestão ${index + 1}: O campo "Area do conhecimento" é obrigatório.`,
          });
        }

        // Continue adicionando outras validações necessárias para sua estrutura
      });
    },
    async getData() {
      this.$loaderService.open("Carregando...");
      const data = await this.$services.censoService.getData("aba50");
      this.formData = data;
      if (data) {
        this.pessoas = data.gestoes;
        this.professores = data.instrutores;
        this.turmasCenso20 = data.turmas;
      }
      this.$loaderService.close();
    },
    async pesquisarCep(cep) {
      // if (cep.length === 9) {
      //   const cepData = await this.$services.cepService.buscarDadosDoCep(cep);
      //   this.formData.cep = cepData.cep;
      //   this.formData.logradouro = cepData.rua;
      //   this.formData.bairro = cepData.bairro;
      //   this.formData.codigo_municipio = cepData.cidade;
      // }
    },
    atualizarEstado(value) {
      if (value) {
        this.municipiosNasc = this.$constants.municipios[value].cidades;
      }
    },

    atualizarEstadoRes(value) {
      if (value) {
        this.municipiosRes = this.$constants.municipios[value].cidades;
      }
    },
    adicionarPessoa() {
      this.pessoas.push({});
      this.abas.push(0);
    },
    removerPessoa(index) {
      this.pessoas.splice(index, 1);
      this.abas.splice(index, 1);
    },

    async submitForm(type) {
      try {
        this.validacao();
        if (!this.erros.length > 0) {
          await this.$services.censoService.saveData(this.pessoas, "aba50");
          if (type === "next") {
            this.$emit("event", "tab-7");
          } else {
            this.$emit("event", "tab-5");
          }
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    formatarCampo(campo) {
      return campo.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },
};
</script>

<style scoped>
.v-card {
  border: 1px solid #ccc;
}
</style>
